export function $stateParamsFactory(i: any) {
    return i.get('$stateParams');
};
export const $stateParamsProvider = { 
    provide: '$stateParams',
    useFactory: $stateParamsFactory,
    deps: ['$injector']
};

// Prueba de hacer un $state 
export function $stateFactory(i: any) {
    return i.get('$state');
};
export const $stateProvider = {
    provide: '$state',
    useFactory: $stateFactory,
    deps: ['$injector']
};

export function datasetsServiceFactory(i: any) {
    return i.get('datasetsService');
}

export const datasetsServiceProvider = {
    provide: 'datasetsService',
    useFactory: datasetsServiceFactory,
    deps: ['$injector']
};

export function loginServiceFactory(i: any) {
    return i.get('LoginService');
}

export const loginServiceProvider = {
    provide: 'LoginService',
    useFactory: loginServiceFactory,
    deps: ['$injector']
};


export function eventServiceFactory(i: any) {
    return i.get('eventService');
}

export const eventServiceProvider = {
    provide: 'eventService',
    useFactory: eventServiceFactory,
    deps: ['$injector']
};

export function notificationServiceFactory(i: any) {
    return i.get('notificationService');
}

export const notificationServiceProvider = {
    provide: 'notificationService',
    useFactory: notificationServiceFactory,
    deps: ['$injector']
};

export function generateDocumentServiceFactory(i: any) {
    return i.get('generateDocumentService');
}

export const generateDocumentServiceProvider = {
    provide: 'generateDocumentService',
    useFactory: generateDocumentServiceFactory,
    deps: ['$injector']
};

export function $rootScopeFactory(i: any) {
    return i.get('$rootScope');
}

export const $rootScopeProvider = {
    provide: '$rootScope',
    useFactory: $rootScopeFactory,
    deps: ['$injector']
};